import { FC, useEffect } from 'react'

import { useLocation } from 'react-router'

import { AppInitialProps } from './@types'
import { useAnalytics } from './hooks/useAnalytics'
import { useFullStory } from './hooks/useFullStory'
import { useOneTimeServerMessage } from './hooks/useOneTimeServerMessage'
import { useBootIntercom } from './lib/intercom/useBootIntercom'

export const TribeWeb: FC<{ pageProps: AppInitialProps }> = ({
  children,
  pageProps,
}) => {
  const location = useLocation()

  useOneTimeServerMessage(pageProps.otsm)
  useBootIntercom({ userHash: pageProps?.intercomUserHash })
  useFullStory()

  const analytics = useAnalytics()

  useEffect(() => {
    analytics.trackPageView(location.pathname)
  }, [location, analytics])

  return <>{children}</>
}
